export const FETCH_EVENT = "FETCH_EVENT";
export const FETCH_EVENTS = "FETCH_EVENTS";
export const FETCH_CONTESTANT = "FETCH_CONTESTANT";
export const UPDATE_CANDIDATES = "UPDATE_CANDIDATES";
export const UPDATE_CANDIDATE = "UPDATE_CANDIDATE";
export const DOWNLOADED_TICKETS = "DOWNLOADED_TICKETS"
